// extracted by mini-css-extract-plugin
export default {"sectionTitle":"sectionTitle___L98Jd"};